import React from "react";
import { NavLink } from "react-router-dom";
import InputLabel from "@material-ui/core/InputLabel";
import Input from "@material-ui/core/Input";
import PasswordInput from "../elements/passwordInput/PasswordInput";
import DefaultButton from "../styles/materialButtonStyle";
import FormHelperText from "@material-ui/core/FormHelperText";
import ValidationFormControl from "../styles/materialValidFormControl";
import axios from "axios";
import basicAuthenticationConfig from "../../utils/basicAuthenticationConfig";
import Cookies from "js-cookie";

import { StyledForm, StyledFormAction, StyledFormContent } from "../styles/styledForm";
import { parseAxiosError } from "../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../utils/consts";

const LoginForm = ({ authData, setAuthData, error, notification, setNotification, t }) => {

  const handleSubmit = (event) => {
    event.preventDefault();

    let data = {
      email: event.target.email.value,
      password: event.target.password.value
    };

    axios.post("/api", {}, basicAuthenticationConfig(data.email, data.password)).then(response => {
      if (response.status === 200) {
        setAuthData({
          ...authData,
          authConfig: basicAuthenticationConfig(data.email, data.password)
        });
      }
      if (response.status === 201) {
        Cookies.set("token", response.data.data.attributes.token);
        if (Cookies.get("token")) {
          window.location.href = "/";
        }
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  return (
    <StyledForm
      onSubmit={handleSubmit}
      className="login-form"
    >
      <StyledFormContent className="login-form__content">
        <ValidationFormControl
          error={error.email && true}
          className="login-form__input"
        >
          <InputLabel htmlFor="eMail">E-mail</InputLabel>
          <Input
            id="eMail"
            required
            type="email"
            name="email"
          />
          {error.email && <FormHelperText id="component-error-text">{error.email}</FormHelperText>}
        </ValidationFormControl>
        <PasswordInput
          label={t("loginPassword")}
          error={error.password}
          id="password"
          className="login-form__input"
          name="password"
        />
      </StyledFormContent>
      <StyledFormAction className="login-form__action">
        <DefaultButton
          color="success"
          type="submit"
        >
          {t("loginSubmit")}
        </DefaultButton>
        <NavLink to="/forgot-password">
          {t("forgotPassword")}
        </NavLink>
      </StyledFormAction>
    </StyledForm>
  );
};

export default LoginForm;